const types = {
    SET_LIST_ORGANIZATION: '[OBJECT] SET LIST ORGANIZATION',
}

export {
    types
}